/**
 * @module geo/actions/creators
 *
 */
import {promiseActionCreator} from '../../helpers/observable.to.promise';
import {SET_FILTER_HISTORY_TIMESTAMP} from '../../payload/facade/SET_FILTER_HISTORY_TIMESTAMP';
import {Acknowledged} from '../../payload/response/acknowledged';
import {actionCreator} from '../helpers/actions.creator.builder';
import {ActionCreator} from '../helpers/fsa';
import {TypeKeyActions} from '../types.key.action';

/**
 * return an action builder to set new filter history timestamp
 * @since v2.1.0
 */
export const setFilterHistoryTimestampCreator =
    actionCreator<SET_FILTER_HISTORY_TIMESTAMP>(
        TypeKeyActions.SET_FILTER_HISTORY_TIMESTAMP) as
    ActionCreator<SET_FILTER_HISTORY_TIMESTAMP>;
/**
 * action type of setFilterHistoryTimestampAsyncCreator
 * @since v2.1.0
 */
export const setFilterHistoryTimestampAsyncCreator =
    actionCreator.async<SET_FILTER_HISTORY_TIMESTAMP,  Acknowledged, Error>(
        TypeKeyActions.SET_FILTER_HISTORY_TIMESTAMP);
/**
 * return an action builder with a promise to set new filter history timestamp
 * @since v 2.0.2
 * @private
 * @hidden
 */
export const setFilterHistoryTimestampCreatorP =
    promiseActionCreator(setFilterHistoryTimestampCreator, [
      setFilterHistoryTimestampAsyncCreator.done.type,
      setFilterHistoryTimestampAsyncCreator.failed.type
    ]);
